import { generateDynamicRoutesTranslations, LANGUAGES } from './common';
import en from '../translations/en.json';
import es from '../translations/es.json';

import extraEN from '../translations/en_pg.json';
import extraES from '../translations/es_pg.json';

export const SUPPORTED_LANGUAGES = [LANGUAGES.en, LANGUAGES.es];
export const DEFAULT_LANGUAGE = LANGUAGES.en;

export const initResources = {
  [LANGUAGES.en]: {
    translation: { ...en, ...extraEN, dynamicRoutes: { ...generateDynamicRoutesTranslations(LANGUAGES.en) } }
  },
  [LANGUAGES.es]: {
    translation: { ...es, ...extraES, dynamicRoutes: { ...generateDynamicRoutesTranslations(LANGUAGES.es) } }
  }
};
